import React, { PropTypes, Component } from "react";
import ComponentFactory from "../utils/ComponentFactory";

import styled from "styled-components";

const SidePanelCard = styled.div`
  position: relative;
  margin-bottom: 20px;
  padding: 20px ${props => props.sidePadding}px;
  background-color: ${props => props.theme.color.white};
  box-shadow: ${props => props.theme.boxShadow["1"]};
  border-radius: 4px;
  opacity: 0.85;
  transition: all .2s ease-in-out;

  &:hover {
    opacity:1;
    transform: scale(1.03);
    cursor:default;
  }
`;

class Card extends Component {
  render() {
    const { children, onPanelClick, sidePadding } = this.props;
    return (
      <SidePanelCard sidePadding={sidePadding}>
        {children.map((child, idx) => {
          const childObj = {
            onPanelClick,
            ...child,
          };
          return <ComponentFactory key={idx} {...childObj} />;
        })}
      </SidePanelCard>
    );
  }
}

Card.defaultProps = {
  sidePadding: 30
};

Card.propTypes = {
  children: PropTypes.array,
  onPanelClick: PropTypes.func,
  sidePadding: PropTypes.number
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/Card.js